export const navEn = {
  main: "Main navigation",
  tabs: "Tabs",
  dashboard: "Dashboard",
  home: "Home",
  call: "Call",
  my_calls: "My calls", // GAVION my-calls
  leads: "Leads",
  contacts: "Contacts",
  deals: "Deals",
  tasks: "Tasks",
  meetings: "Meetings",
  email: "Email",
  drafts: "Drafts", // GAVION ai-email
  reports: "Reports",
  recruiting: "Recruiting", // GAVION recruiting
  training: "Training",
  settings: "Settings",
  more: "More",
  in_session: "In session",
  call_in_progress: "Call in progress",
  toggle_sidebar: "Toggle menu",
  user_menu: "Account menu",
  my_profile: "My profile",
  configuration: "Configuration",
  import_data: "Import data",
  coming_soon: "Coming soon",
  coming_soon_hint: "This page is on its way.",
  integrations: "Integrations",
};
